"use client";
import dynamic from "next/dynamic";
import { Button, useDisclosure } from "@nextui-org/react";
import {
  AccreOverImg,
  BgImg2Wrap,
  ContentContainer,
} from "../../../../components/molecules";
import ExitPic from "../../../../../public/learning_objectives.jpg";

const ArrowRightIcon = dynamic(() =>
  import("../../../../assets/svg/ArrowRightIcon")
);

const NewEnquireModal = dynamic(() =>
  import("../../../../components/modal/NewEnquireModal")
);

const KeyBenefitsSection = ({ keyBenefitsData, dict, course, params }) => {
  const { isOpen, onOpenChange } = useDisclosure();

  // Debug logs
  console.log('keyBenefitsData:', keyBenefitsData);
  console.log('benefits array:', keyBenefitsData?.benefits);
  console.log('benefits length:', keyBenefitsData?.benefits?.length);

  return (
    <>
      <div className="w-full relative mb-6">
        <BgImg2Wrap overviewClass="absolute top-auto bottom-[270px] sm:top-32 sm:bottom-auto 2xl:top-[9.5rem] left-0" />
        <ContentContainer>
          <div className="px-10 md:px-20 pt-20 pb-28 relative border-[1.2px] border-black rounded-2xl z-10 bg-white lg:min-h-[30rem]">
            <div className="grid grid-cols-1 lg:grid-cols-[35%_1fr] gap-3">
              <div>
                <h3 className="mb-2 text-[32px] lg:text-5xl font-extrabold">
                  {keyBenefitsData?.heading || "Key Benefits"}
                </h3>
                {keyBenefitsData?.sub_heading && (
                  <p className="text-base font-normal tracking-[0.48px] text-black leading-[170%]">
                    {keyBenefitsData.sub_heading}
                  </p>
                )}
              </div>

              {/* Benefits List with Arrow Icons */}
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4 lg:mt-0">
                {keyBenefitsData?.benefits?.length > 0 ? (
                  keyBenefitsData.benefits.map((benefit, index) => {
                    console.log(`Benefit ${index}:`, benefit);
                    return (
                      <li className="flex text-[16px] text-black gap-3" key={index}>
                        <span className="flex-shrink-0 mt-1">
                          <ArrowRightIcon className="stroke-[#214F9A]" />
                        </span>
                        <span className="flex-1">
                          {benefit?.long_description?.includes(":") ? (
                            <>
                              <strong className="font-semibold">
                                {benefit.long_description.split(":")[0]}:
                              </strong>
                              {benefit.long_description.split(":").slice(1).join(":")}
                            </>
                          ) : (
                            benefit?.long_description
                          )}
                        </span>
                      </li>
                    );
                  })
                ) : (
                  <li className="text-gray-500">No benefits available</li>
                )}
              </ul>
            </div>

            <AccreOverImg
              className={`-left-[1px] ${dict?.dir === "rtl" && "!right-auto"}`}
              styled={{ transform: "rotateY(180deg)" }}
              fill="#ffda73"
            />

            <Button
              className={`absolute left-0 right-auto bottom-[3.7px] min-w-0 max-w-full w-auto h-auto bg-black text-white rounded-full py-3 px-4 text-[13px] z-20 font-semibold`}
              onClick={(e) => {
                e.stopPropagation();
                onOpenChange();
              }}
            >
              {dict?.enquireNow || "Enquire Now"}
            </Button>
          </div>
        </ContentContainer>

        {isOpen && (
          <NewEnquireModal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            course={course}
            section="key_benefits"
            submitEventName="Key Benefits Enquire Now"
            closeEventName="Key Benefits Enquire Now X"
            image={ExitPic}
          />
        )}
      </div>
    </>
  );
};

export default KeyBenefitsSection;